import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, InputBase } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import { error } from '@root/views/Authentication/components/SharedComponents/SharedComponents';
import AddSpacing from '@root/components/AddSpacing';
import SimpleTooltip from '@root/components/tooltips/SimpleTooltip';
import eventsAggregator, { EVENT_NAMES } from '@root/services/eventsAggregator';

import useFraseFile from '../resources/useFraseFile';
import useFraseGeneration from '../resources/useFraseGeneration';

import FraseAccordion from './FraseAccordion';
import useStyles from './FraseDrawer.styles';

const FraseDrawer = ({
  generation,
  setSelectedGen,
  selectedGen,
}) => {
  const classes = useStyles();
  const [queryText, setQueryText] = useState('');
  // const [selectedGen, setSelectedGen] = useState(0);
  const [wordCount, setWordCount] = useState({});
  const [options, setOptions] = useState([]);
  const {
    data: mutateData, isLoading, mutate, isError,
  } = useFraseGeneration();

  const { data: queryData, isFetching } = useFraseFile(
    generation[selectedGen].id,
  );

  const parseText = () => {
    const countWords = {};
    options.forEach((cluster) => {
      cluster.cluster_entities.forEach((item) => {
        // only parse if new
        if (!countWords[item.entity]) {
          countWords[item.entity] = generation[selectedGen].content
            .toLowerCase()
            .replace(/(<([^>]+)>)/gi, '')
            .split(item.entity.toLowerCase()).length - 1;
        }
      });
    });
    setWordCount(countWords);
  };

  const nextIndex = (val) => {
    let index = selectedGen + val;
    if (index >= generation.length) index = 0;
    else if (index < 0) index = generation.length - 1;

    if (setSelectedGen) {
      setSelectedGen(index);
    }
  };

  useEffect(() => {
    if (queryData && queryData.content) {
      setQueryText(queryData.content.query);
      setOptions(queryData.content.clusters);
    } else {
      setQueryText('');
      setOptions([]);
    }
  }, [queryData]);

  useEffect(() => {
    if (mutateData) {
      setOptions(mutateData);
    } else if (isError) {
      error('Sorry there was an issue generating your results!');
    }
  }, [mutateData, isError]);

  useEffect(() => {
    // parse text, set null if not initiated
    if (options && options.length) {
      parseText();
    } else {
      setWordCount({});
    }
  }, [options]);

  const generateSerp = () => {
    const queryObj = {
      content: queryText,
      lang: 'en',
      country: 'us',
      documentId: generation[selectedGen].id,
    };
    mutate(queryObj);

    eventsAggregator.publish(EVENT_NAMES.FRASE_SEARCH_QUERY_PROCESSED, { query: queryText });
  };

  return (
    <AddSpacing spacing={20}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          justifyContent="center"
          item
          xs={9}
        >
          <span className={classes.title}>
            <b>Frase Topic Clusters</b>
            <SimpleTooltip
              interactive
              content={(
                <span>
                  {'Keywords from top search subtopics will be listed under a corresponding cluster. Improve your SEO by incorporating the same count of keywords as your targeted cluster. '}
                  <br />
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://describely.notion.site/Find-SEO-Optimized-Keywords-Powered-By-Frase-3d89c7193952445691bdf6bf5e17d174"
                  >
                    Learn more here!
                  </a>
                </span>
                )}
              placement="right"
              className={classes.tooltip}
            >
              <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
            </SimpleTooltip>
          </span>
        </Grid>
        <Grid
          justifyContent="center"
          item
          xs={3}
        >
          <FontAwesomeIcon
            icon="chevron-left"
            className={classes.chevronStyle}
            onClick={() => {
              nextIndex(-1);
            }}
          />

          <span
            className={classes.selectedGenCounter}
          >
            {selectedGen + 1}
          </span>

          <FontAwesomeIcon
            icon="chevron-right"
            className={classes.chevronStyle}
            onClick={() => {
              nextIndex(1);
            }}
          />
        </Grid>
      </Grid>
      <Grid container>
        <InputBase
          placeholder="What is your targeted search query"
          type="text"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              generateSerp();
            }
          }}
          onChange={(event) => setQueryText(event.target.value)}
          value={queryText}
          className={classes.searchInput}
          endAdornment={(
            <FontAwesomeIcon
              icon="search"
              className={classes.searchStyle}
              onClick={generateSerp}
            />
            )}
        />
      </Grid>
      <Grid container>
        <FraseAccordion
          loading={isLoading || isFetching}
          options={options}
          wordCount={wordCount}
        />
      </Grid>
    </AddSpacing>
  );
};

export default FraseDrawer;
